import React from 'react';
import { STATUS_LABELS } from '@/lib/format';

export function JobStatusPill({ status, className = '' }) {
  const label = STATUS_LABELS[status] || status;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium status-${status} ${className}`}
      aria-label={label}
      data-testid={`job-status-pill-${status}`}
    >
      <span className={`h-2 w-2 rounded-full dot-${status}`} />
      {label}
    </span>
  );
}
